/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Manageroles_Selectall2Inputs */

const en_settings_collaborators_manageroles_selectall2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Selectall2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select all (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Select all ({count})" |
*
* @param {Settings_Collaborators_Manageroles_Selectall2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_selectall2 = /** @type {((inputs: Settings_Collaborators_Manageroles_Selectall2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Selectall2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_selectall2(inputs)
});
export { settings_collaborators_manageroles_selectall2 as "settings_collaborators_manageRoles_selectAll" }